import React from "react";
import Sidebar from "./Sidebar";
import { Outlet, useLocation } from "react-router-dom";
import "../css/CufrontOutlet.css";
import { useMediaQuery } from "react-responsive";

const AvailibilityTest = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const step = searchParams.get("step");
  const lg = useMediaQuery({ query: "(min-width:1024px)" });

  //(step, "sdkjhsakj");

  return (
    <div>
      {/* {location.pathname === "/new/chat" && !lg ? <></> : <Sidebar />} */}
      {location.pathname !== "/new/clinicshow" && <Sidebar />}
      <div
        // className={`${
        //   location.pathname === "/new/chat"
        //     ? "cufront-outlet-chat"
        //     : "cufront-outlet"

        // }`}
        className={`${
          location.pathname !== "/new/clinicshow" && step === null
            ? "cufront-outlet"
            : ""
        }`}
      >
        <Outlet />
      </div>
    </div>
  );
};

export default AvailibilityTest;
